import React, { forwardRef, useEffect, useState } from 'react';

import { Input } from '@vlabs/uikit/components/controls/input';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useUserFiltersTranslation } from '../i18n';
import { useUserListFilters } from '../useUserListPageFilters';
import st from './popovers.module.sass';

function UserEmailFilterPopover(
  {
    ...props
  }: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useUserFiltersTranslation();
  const [localValue, setLocalValue] = useState<string>('');
  const { filters, updateFilters, updateFiltersDebounced } = useUserListFilters();

  const onChangeHandler = (userEmail: string) => {
    setLocalValue(userEmail);
    updateFiltersDebounced({ email: userEmail });
  };

  useEffect(() => {
    setLocalValue(filters.email ?? '');
  }, [filters.email]);

  const reset = () => {
    updateFilters({ email: undefined });
  };

  return (
    <PopoverWithButton
      {...props}
      data-testid="email"
      onClickReset={reset}
      ref={ref}
      title={<div className={st.PopoverTitle}>{t('email.label')}</div>}
    >
      <Input
        isClearable
        onChangeValue={onChangeHandler}
        onClear={reset}
        value={localValue}
      />
    </PopoverWithButton>
  );
}

const UserEmailFilterPopoverWithRef = forwardRef(UserEmailFilterPopover);
export { UserEmailFilterPopoverWithRef as UserEmailFilterPopover };
